import { render, staticRenderFns } from "./InvoiceTips.vue?vue&type=template&id=40385381&scoped=true"
import script from "./InvoiceTips.vue?vue&type=script&lang=js"
export * from "./InvoiceTips.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTips.vue?vue&type=style&index=0&id=40385381&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40385381",
  null
  
)

export default component.exports